import { gql } from '@apollo/client';

export const TRANSFER_RECEIVE_MONEY = gql`
  mutation transfiyaReceiveResponse(
    $transfiyaReceiveRequest: TransfiyaReceiveRequest!
    $accountId: String!
  ) {
    transfiyaReceiveResponse(
      transfiyaReceiveRequest: $transfiyaReceiveRequest
      accountId: $accountId
    ) {
      amount
      approvalId
      rquid
    }
  }
`;

export const TRANSFER_CONFIRMATION = gql`
  query transactionConfirmation(
    $accountId: String!
    $transferType: String!
    $approvalId: String!
    $amount: Float!
    $rquid: String!
  ) {
    transactionConfirmation(
      accountId: $accountId
      transferType: $transferType
      approvalId: $approvalId
      amount: $amount
      rquid: $rquid
    ) {
      data {
        totalAmount
        transactionDate
        confirmationNumber
        linkedTransactionId
        chargesInfo {
          gmf
          fee
          tax
        }
      }
    }
  }
`;
